/**
 * 反转义
 * @param {string} str 转义后的字符串
 * @return {string} 反转义后的字符串
 */
export function htmlDecode(str) {
  return (`${str}`)
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, '\'')
    .replace(/&quot;/g, '"')
    .replace(/&nbsp;/g, ' ')
    .replace(/&#61;/g, '=')
    .replace(/&#96;/g, '`');
}

export const htmlDecimalEncode = function (str) {
  return (`${str}`)
    .replace(/&/g, '&#38;')
    .replace(/</g, '&#60;')
    .replace(/>/g, '&#62;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&#34;')
    // .replace(/ /g, '&#160;')
    .replace(/=/g, '&#61;')
    .replace(/`/g, '&#96;');
};

/**
   * 反转义
   * @param {string} str 转义后的字符串
   * @return {string} 反转义后的十进制字符串
   */
export function htmlDecimalDecode(str) {
  return (`${str}`)
    .replace(/&#38;/g, '&')
    .replace(/&#60;/g, '<')
    .replace(/&#62;/g, '>')
    .replace(/&#39;/g, '\'')
    .replace(/&#34;/g, '"')
    .replace(/&#160;/g, ' ')
    .replace(/&#61;/g, '=')
    .replace(/&#96;/g, '`');
}

